import { ChangeEvent, useState } from 'react';
import { FormField } from '../FormField';
import './password.styles.css'
 
type PasswordFieldProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  maxLength?: number;
  className?: string;
};
 
export const PasswordField = ({
  label,
  value,
  onChange,
  error,
  placeholder = 'Ingresa tu contraseña',
  maxLength,
  className
}: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
 
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	onChange(e.target.value);
  };
 
  const togglePasswordVisibility = () => {
	setShowPassword(!showPassword);
  };
 
  return (
	<FormField label={label} error={error} className={className}>
	  <div className="password-container">
		<input
		  type={showPassword ? 'text' : 'password'}
		  className="form-input password-input"
		  value={value}
		  onChange={handleChange}
		  placeholder={placeholder}
		  maxLength={maxLength}
		/>
		<button
		  type="button"
		  className="password-toggle"
		  onClick={togglePasswordVisibility}
		  tabIndex={-1} // Para que no interfiera con el tab navigation
		  title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
		>
		  {showPassword ? '🙈' : '👁️'}
		</button>
	  </div>
	</FormField>
  );
};